/* GENERATED by scripts/gen-data.mjs — film scene registry (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';
import { F_FOUNDATIONS } from './foundations';
import { F_FAMILIES } from './families';
import { F_GROUNDING } from './grounding';
import { F_MEMORY } from './memory';
import { F_DEPLOY } from './deploy';
import { F_MONITOR } from './monitor';
import { F_BUS } from './bus';
import { F_SPLIT } from './split';
import { F_FRONTEND } from './frontend';
import { F_TOOLING } from './tooling';
import { F_GUARD } from './guard';
import { F_EVALUATE } from './evaluate';
import { F_PRODUCTION } from './production';
import { F_SOFTMAX } from './softmax';
import { F_DELIVERY } from './delivery';
import { F_DRIFT } from './drift';
import { F_COST } from './cost';

export const FILMS: Record<string, FilmScene> = {
  "f-foundations": F_FOUNDATIONS,
  "f-families": F_FAMILIES,
  "f-grounding": F_GROUNDING,
  "f-memory": F_MEMORY,
  "f-deploy": F_DEPLOY,
  "f-monitor": F_MONITOR,
  "f-bus": F_BUS,
  "f-split": F_SPLIT,
  "f-frontend": F_FRONTEND,
  "f-tooling": F_TOOLING,
  "f-guard": F_GUARD,
  "f-evaluate": F_EVALUATE,
  "f-production": F_PRODUCTION,
  "f-softmax": F_SOFTMAX,
  "f-delivery": F_DELIVERY,
  "f-drift": F_DRIFT,
  "f-cost": F_COST,
};
